import React from "react";
import style from "./index.module.scss";

const CardOverlay = (porps) => {
  const post = porps.post;
  return (
    <div id={porps.id} className={style['card']} style={{backgroundImage: `url(${post.img})`}}>
      <div className={style.inner}>
        <hgroup>
          <h2 className={style['card-title']}>{post.title}</h2>
          <h3 className={style['card-subtitle']}>{post.subtitle}</h3>
        </hgroup>
        <p>{post.text}</p>
        <p className="align-center">
          <a href={post.link} className="btn btn-light" target="_blank" rel="noreferrer noopener">READ MORE+</a>
        </p>
      </div>
    </div>
  )
};

export default CardOverlay;
